export enum Criticality {
  Normal = 'normal',
  Critical = 'critical',
  Blocking = 'blocking'
}
